import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../axios';

export const fetchTemplates = createAsyncThunk(
  'templates/fetchTemplates',
  async () => {
    console.log("Fetching templates from API");
    const response = await axiosInstance.get('/templates');
    console.log("Received templates:", response.data);
    return response.data;
  }
)

const templatesSlice = createSlice({
  name: 'templates',
  initialState: {
    data: [],
    status: 'idle',
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTemplates.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchTemplates.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchTemplates.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  }
})

export default templatesSlice.reducer;